module.exports = __webpack_public_path__ + "img/vecernji-list.be0f2e41.svg";